<form
    [formGroup]="editform"
    autocomplete="off"
    (ngSubmit)="editform.valid && saveFn()"
>
    <div class="conn-card">
        <div class="flex row py-2">
            <div class="col-8 pl-0">
                <label class="control-label">
                    <strong>
                        Full Name
                        <span style="color: red; font-size: 1.25rem">*</span>
                    </strong>
                </label>
                <br />
                <app-text-input
                    [formControl]="$any(editform.controls)['fullName']"
                    [name]="'Full Name'"
                    [description]="fullNameDescription"
                    [label]=""
                >
                </app-text-input>
            </div>

            <div class="col-4 pr-0">
                <label class="control-label">
                    <strong>
                        Status
                        <span style="color: red; font-size: 1.25rem">*</span>
                    </strong>
                </label>
                <br />
                <p-dropdown
                    [formControl]="$any(editform.controls)['status']"
                    [style]="{}"
                    class="p-dropdown-1"
                    [options]="statusList"
                    optionLabel="viewValue"
                    optionValue="id"
                    [autoDisplayFirst]="false"
                >
                </p-dropdown>
                <div
                    *ngIf="
                        $any(editform.controls)['status'].invalid &&
                        $any(editform.controls)['status'].touched
                    "
                    class="invalid-feedback"
                >
                    Please select a status
                </div>
            </div>
        </div>
        <div class="conn-grid py-2">
            <div>
                <label class="control-label py-2">
                    <strong>
                        Description
                        <span style="color: red; font-size: 1.25rem"></span>
                    </strong>
                </label>
                <br />
                <textarea
                    [rows]="5"
                    [cols]="30"
                    [autoResize]="true"
                    class="mt-2"
                    [formControl]="$any(editform.controls)['description']"
                    pInputTextarea
                    style="width: 100%"
                >
                ​</textarea
                >
            </div>
        </div>
        <!-- Coupon Selection Section -->
        <div class="conn-grid py-2">
            <div
                *ngIf="isCouponLoading"
                class="flex align-items-center gap-2 py-2"
            >
                <i
                    class="pi pi-spin pi-spinner"
                    style="font-size: 1.2rem; color: #fa4b1b"
                ></i>
                <span>Loading coupons...</span>
            </div>
            <span *ngIf="!isViewOnly">
                <p-autoComplete
                    #couponAuto
                    [(ngModel)]="selectedCoupon"
                    [ngModelOptions]="{ standalone: true }"
                    [suggestions]="filteredCoupons"
                    (completeMethod)="filterCoupons($event)"
                    field="name"
                    placeholder="Search or select coupons"
                    [dropdown]="true"
                    appendTo="body"
                    (onSelect)="addCoupon($event, couponAuto)"
                    class="w-full mt-2"
                >
                </p-autoComplete>
            </span>
            <!-- ADD NEW COUPON BUTTON (isNew = true only) -->
            <button
                *ngIf="isNew && !isViewOnly"
                pButton
                class="p-button-sm p-button-text mt-2"
                icon="pi pi-plus"
                label="Create New Coupon"
                (click)="openNewCouponForm()"
            ></button>
            <div class="flex flex-wrap gap-2 mt-3">
                <span
                    *ngFor="let coupon of assignedCoupons; let i = index"
                    class="bg-gray-100 text-gray-700 border-round-md px-3 py-1 text-sm flex align-items-center gap-2"
                >
                    {{ coupon.name }}
                    <i
                        *ngIf="!isViewOnly"
                        class="pi pi-times text-red-500 cursor-pointer"
                        (click)="removeCouponByIndex(i)"
                    ></i>
                </span>
            </div>
        </div>
        <div *ngIf="!isNew">
            <p-table
                #dt
                [tableStyle]="{ width: 'min-content' }"
                [value]="couponArray"
                *ngIf="couponArray.length > 0"
                [autoLayout]="true"
                [paginator]="false"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} discounts"
                [rowsPerPageOptions]="[5, 10, 50]"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th style="text-align: center">Code</th>
                        <th style="text-align: start">Url</th>
                        <th style="text-align: start">Copy</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                    <tr [pSelectableRow]="item" class="text-center">
                        <td style="text-align: center">{{ item.x }}</td>
                        <td style="text-align: start">{{ item.y }}</td>
                        <td
                            style="text-align: start; color: var(--brandColor)"
                            (click)="copy(item)"
                            class="cursor-pointer"
                        >
                            <i class="pi pi-copy"></i>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
       
    </div>

    <p-divider [style]="'margin-top: 10px;'"></p-divider>
    <div class="grid">
        <div class="col">
           <div class="flex justify-content-start" *ngIf="errorMessage !=''">
                <p class="danger">{{errorMessage}}</p>
            </div>
            <div
                class="flex justify-content-end flex-wrap card-container green-container mt-3"
            >
                <div class="flex align-items-center justify-content-center">
                    <button
                        pButton
                        pRipple
                        type="submit"
                        label="Save"
                        [disabled]="!editform.valid"
                        *ngIf="!isViewOnly"
                        [style]="{ width: '120px' }"
                    ></button>
                </div>
                <div
                    class="flex align-items-center justify-content-center ml-2"
                >
                    <button
                        pButton
                        pRipple
                        type="button"
                        label="Cancel"
                        class="p-button-outlined p-button-danger"
                        (click)="cancelButtonClick()"
                        [style]="{ width: '120px' }"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</form>
<p-dialog
    [(visible)]="showCouponModal"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    header="Create New Coupon"
        [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
        [style]="{ width: '60vw', maxWidth: '100%' }"
        [contentStyle]="{ 'max-height': '80vh', overflow: 'auto' }"
    (onHide)="closeCouponModal()"
>
    <app-bizz-coupon-codes-form
        [isNew]="true"
        [isViewOnly]="false"
        (onSubmit)="onCouponCreated($event); closeCouponModal()"
    >
    </app-bizz-coupon-codes-form>
</p-dialog>
